"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const icons_1 = require("client/components/icons");
const icons_2 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const store_1 = require("client/modules/app-settings/store");
const iframe_preview_1 = require("client/modules/inventory-order/tabs/order-review/components/iframe-preview");
const store_2 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda = require("ramda");
const ramda_1 = require("ramda");
const React = require("react");
require("./asset-list.less");
let AssetList = class AssetList extends React.Component {
    constructor() {
        super(...arguments);
        this.iframeUrl = "";
        this.editDescriptionMode = false;
        this.certificationMode = false;
        this.connectAssetMode = false;
        this.uploadsLocal = [];
        this.invoiceUploadsLocal = [];
        this.connectAssetCategories = [];
        this.categoryUpdateModal = false;
        this.selectedCategory = null;
        this.generateCategoryNames = async () => {
            const categories = await store_1.appSettingsStore.readConnectAsset(this.props.entityType);
            if (categories) {
                const cleaned = categories
                    .filter((category) => category.deletedAt === null)
                    .sort((a, b) => a.categoryName > b.categoryName ? 1 : -1)
                    .map((e) => e);
                this.connectAssetCategories.push({
                    id: 0,
                    label: "--",
                    value: "0"
                });
                cleaned.forEach((category, i) => this.connectAssetCategories.push({
                    id: i + 1,
                    label: category.categoryName,
                    value: `${category.id}`
                }));
            }
            else {
                this.connectAssetCategories = [];
            }
        };
        this.initializeUploadsDescription = () => {
            this.uploadsLocal = [];
            this.invoiceUploadsLocal = [];
            if (this.props.uploads) {
                for (const upload of this.props.uploads) {
                    this.uploadsLocal.push(ramda_1.clone(upload));
                }
            }
            if (this.props.invoiceUploads) {
                for (const invoiceUpload of this.props.invoiceUploads) {
                    this.invoiceUploadsLocal.push(ramda_1.clone(invoiceUpload));
                }
            }
        };
        this.saveUploadsDescriptions = () => {
            if (this.props.invoiceUploads) {
                this.props.onDescriptionSave(this.invoiceUploadsLocal);
            }
            else if (this.props.uploads) {
                this.props.onDescriptionSave(this.uploadsLocal);
            }
            if (this.certificationMode) {
                this.props.onExpDateSave(this.uploadsLocal);
            }
            if (this.connectAssetMode) {
                this.props.onConnectAssetSave(this.uploadsLocal);
            }
        };
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
        this.handleClick = (upload) => () => {
            this.iframeUrl = `${upload.filePath}`;
            this.activeFile = upload;
        };
        this.handleInvoiceClick = (upload) => () => {
            this.iframeUrl = `${upload.path}`;
            this.activeInvoiceFile = upload;
        };
        this.handleInvoiceAssetDescriptionChange = (upload) => (event, value) => {
            upload.description = value;
        };
        this.handleAssetDescriptionChange = (upload) => (event, value) => {
            upload.description = value;
        };
        this.handleAssetExpDate = (upload) => (value) => {
            upload.expDate = value;
        };
        this.handleConnectAssetUpdate = (upload, index) => (value) => {
            // checks if the selected category id is used on another asset, except from the current one,
            // to avoid showing the modal if they select the same category in the same asset
            const categoryIsUsed = this.uploadsLocal.filter((upload, i) => upload.connectAssetId === Number(value) && i !== index);
            if (categoryIsUsed && categoryIsUsed.length > 0) {
                this.prevAsset = categoryIsUsed[0];
                this.currentAsset = upload;
                this.selectedCategory = Number(value);
                this.categoryUpdateModal = !this.categoryUpdateModal;
            }
            else {
                upload.connectAssetId = Number(value);
            }
        };
        this.handleCategoryUpdate = async () => {
            this.prevAsset.connectAssetId = null;
            this.currentAsset.connectAssetId = this.selectedCategory;
            this.categoryUpdateModal = false;
        };
        this.toggleEditDescription = () => {
            this.editDescriptionMode = !this.editDescriptionMode;
        };
        this.toggleCertification = () => {
            this.certificationMode = !this.certificationMode;
        };
        this.toggleConnectAsset = () => {
            this.connectAssetMode = !this.connectAssetMode;
        };
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
        };
        this.handleCredentialUpload = () => {
            this.props.onCredentialUpload &&
                this.props.onCredentialUpload(this.props.entityData);
        };
        this.handleInvoiceUpload = () => {
            this.props.onInvoiceUpload && this.props.onInvoiceUpload();
        };
        this.handleImageUpload = () => {
            this.props.onImageUpload && this.props.onImageUpload(this.props.entityData);
        };
        this.handleDeleteFile = (upload) => {
            this.props.onDeleteUpload(upload);
        };
        this.isChanged = () => {
            let resultDesc = [];
            let resultDate = [];
            let resultCategory = [];
            let resultInvDesc = [];
            if (this.props.uploads) {
                resultDesc = ramda.symmetricDifference(this.uploadsLocal.map((upload, index) => ({
                    value: upload.description,
                    index
                })), this.props.uploads.map((upload, index) => ({
                    value: upload.description,
                    index
                })));
                resultDate = ramda.symmetricDifference(this.uploadsLocal.map(upload => upload.expDate), this.props.uploads.map(upload => upload.expDate));
                resultCategory = ramda.symmetricDifference(this.uploadsLocal.map((upload, index) => ({
                    value: upload.connectAssetId,
                    index
                })), this.props.uploads.map((upload, index) => ({
                    value: upload.connectAssetId,
                    index
                })));
            }
            if (this.props.invoiceUploads) {
                resultInvDesc = ramda.symmetricDifference(this.invoiceUploadsLocal.map((upload, index) => ({
                    value: upload.description,
                    index
                })), this.props.invoiceUploads.map((upload, index) => ({
                    value: upload.description,
                    index
                })));
            }
            return (resultDesc.length > 0 ||
                resultDate.length > 0 ||
                resultCategory.length > 0 ||
                resultInvDesc.length > 0);
        };
    }
    componentWillMount() {
        this.initializeUploadsDescription();
    }
    componentWillReceiveProps(props) {
        this.uploadsLocal = [];
        this.invoiceUploadsLocal = [];
        if (props.uploads) {
            for (const upload of props.uploads) {
                this.uploadsLocal.push(ramda_1.clone(upload));
            }
        }
        if (props.invoiceUploads) {
            for (const invoiceUpload of props.invoiceUploads) {
                this.invoiceUploadsLocal.push(ramda_1.clone(invoiceUpload));
            }
        }
    }
    async componentDidMount() {
        await this.generateCategoryNames();
    }
    get assets() {
        return this.props.uploads
            ? this.uploadsLocal.map((upload, index) => {
                const canDelete = store_2.usersStore.user.value &&
                    (store_2.usersStore.user.value.admin ||
                        store_2.usersStore.user.value.manager ||
                        store_2.usersStore.user.value.siteAdmin ||
                        store_2.usersStore.user.value.id === upload.uploadUserId);
                return (React.createElement(material_ui_1.ListItem, { className: "asset-list__file", key: index },
                    React.createElement("div", { className: "asset-list__filename" },
                        React.createElement("span", { className: "asset-list__filename__review-icon" }, upload.approved ? (React.createElement(icons_1.CheckmarkIcon, { fill: "#61B329" })) : upload.rejected ? (React.createElement(icons_1.CloseIcon, { fill: "#FF0000" })) : ("")),
                        React.createElement(icons_1.HistoryIcon, null),
                        this.editDescriptionMode ? (React.createElement(text_field_1.MaterialTextField, { label: `Description (${upload.fileOriginalName})`, placeholder: upload.fileOriginalName, value: upload.description, onChange: this.handleAssetDescriptionChange(upload) })) : (React.createElement("a", { className: "asset-list-link", onClick: this.handleClick(upload) }, upload.fileOriginalName)),
                        this.certificationMode && (React.createElement(date_picker_1.MaterialDatePicker, { className: "certificate-exp-date", label: "Expiration Date", onChange: this.handleAssetExpDate(upload), value: upload.expDate || null })),
                        this.connectAssetMode && (React.createElement(select_1.MaterialSelect, { className: "connect-asset", options: [...this.connectAssetCategories], searchable: true, label: "Requirement", onSelect: this.handleConnectAssetUpdate(upload, index), value: `${upload.connectAssetId}` || "" }))),
                    canDelete && (React.createElement("a", { className: "asset-list-icon", onClick: () => this.handleDeleteFile(upload.id) },
                        React.createElement(icons_2.DeleteIcon, null)))));
            })
            : this.props.invoiceUploads
                ? this.invoiceUploadsLocal.map((upload, index) => (React.createElement(material_ui_1.ListItem, { className: "asset-list__file", key: index },
                    React.createElement("div", { className: "asset-list__filename" },
                        React.createElement(icons_1.HistoryIcon, null),
                        this.editDescriptionMode ? (React.createElement(text_field_1.MaterialTextField, { label: `Description (${upload.originalname})`, placeholder: upload.originalname, value: upload.description, onChange: this.handleInvoiceAssetDescriptionChange(upload) })) : (React.createElement("a", { className: "asset-list-link", onClick: this.handleInvoiceClick(upload) }, upload.originalname))),
                    React.createElement("a", { className: "asset-list-icon", onClick: () => this.handleDeleteFile(upload.id) },
                        React.createElement(icons_2.DeleteIcon, null)))))
                : null;
    }
    render() {
        var _a;
        const image = this.props.uploads
            ? this.props.uploads.find((upload) => upload.informationType === `${this.props.entityType}Image`)
            : null;
        const typesWithImage = this.props.entityType === "user" || this.props.entityType === "patient";
        return (React.createElement("div", null,
            React.createElement("div", { style: { marginBottom: "1.5rem" } },
                React.createElement("div", { className: "user-upload" },
                    React.createElement(icons_1.UploadDocumentIcon, null),
                    React.createElement("div", null,
                        React.createElement("a", { onClick: this.props.onInvoiceUpload
                                ? this.handleInvoiceUpload
                                : this.handleCredentialUpload, href: "#" }, "ATTACH DOCUMENTS"))),
                (image === null || !image) &&
                    !this.props.onInvoiceUpload &&
                    typesWithImage ? (React.createElement("div", { className: "user-upload" },
                    React.createElement(icons_1.UploadDocumentIcon, null),
                    React.createElement("div", null,
                        React.createElement("a", { onClick: this.handleImageUpload, href: "#" }, "ATTACH IMAGE")))) : null),
            ((_a = this.props) === null || _a === void 0 ? void 0 : _a.isAttachDocs) ? null : (React.createElement("div", { className: "filter-header__action" },
                (this.props.entityType === "provider" ||
                    this.props.entityType === "patient" ||
                    this.props.entityType === "user" ||
                    this.props.entityType === "site") && (React.createElement(switch_1.MaterialSwitch, { label: "Add/Edit Expiration Date", value: "true", checked: this.certificationMode, onChange: this.toggleCertification })),
                (this.props.entityType === "provider" ||
                    this.props.entityType === "patient" ||
                    this.props.entityType === "user" ||
                    this.props.entityType === "site") && (React.createElement(switch_1.MaterialSwitch, { label: "Connect Asset", value: "true", checked: this.connectAssetMode, onChange: this.toggleConnectAsset })),
                React.createElement(switch_1.MaterialSwitch, { label: "Edit Description", value: "true", checked: this.editDescriptionMode, onChange: this.toggleEditDescription }))),
            React.createElement("ul", { className: "asset-list__file-list" }, this.assets),
            this.editDescriptionMode ||
                this.certificationMode ||
                this.connectAssetMode ? (React.createElement("div", { className: "edit-description-mode-save" },
                React.createElement(button_1.MaterialButton, { onClick: this.handleCancelClick }, "Close"),
                React.createElement(button_1.MaterialButton, { primary: true, onClick: this.saveUploadsDescriptions, disabled: !this.isChanged() }, "Save"))) : null,
            this.categoryUpdateModal ? (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Update", cancelText: "Go back", message: `Please confirm asset category update. <br /><br />The selected asset category is currently assigned to another asset. 
            By confirming the current selection, the category will be unassigned from the other asset and will be assigned to the current asset.
            <br /><br />Do you want to proceed with the update?`, onCancel: () => (this.categoryUpdateModal = false), onConfirm: this.handleCategoryUpdate, title: "Update Confirmation" })) : null,
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.props.onInvoiceUpload
                    ? this.activeInvoiceFile.originalname
                    : this.activeFile.fileOriginalName, onClose: this.handlePreviewClose, iframeUrl: this.iframeUrl, download: this.iframeUrl })) : null));
    }
};
__decorate([
    mobx_1.observable
], AssetList.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "activeFile", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "activeInvoiceFile", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "editDescriptionMode", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "certificationMode", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "connectAssetMode", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "uploadsLocal", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "invoiceUploadsLocal", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "connectAssetCategories", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "categoryUpdateModal", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "currentAsset", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "prevAsset", void 0);
__decorate([
    mobx_1.observable
], AssetList.prototype, "selectedCategory", void 0);
AssetList = __decorate([
    mobx_react_1.observer
], AssetList);
exports.AssetList = AssetList;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/asset-list/asset-list.tsx
// module id = 3429
// module chunks = 0